const ChevronUp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_462_9205"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect x="24" y="24" width="24" height="24" transform="rotate(-180 24 24)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_462_9205)">
        <path
          d="M12.0066 9.06328C12.1398 9.06328 12.2646 9.08424 12.3812 9.12615C12.4977 9.1674 12.6059 9.23792 12.7058 9.33771L17.3256 13.9532C17.5087 14.1362 17.596 14.365 17.5873 14.6398C17.5793 14.9139 17.4838 15.1424 17.3006 15.3254C17.1175 15.5083 16.8844 15.5998 16.6014 15.5998C16.3184 15.5998 16.0853 15.5083 15.9022 15.3254L12.0066 11.4334L8.08603 15.3503C7.9029 15.5333 7.67383 15.6208 7.39881 15.6128C7.12445 15.6041 6.89571 15.5083 6.71258 15.3254C6.52946 15.1424 6.43789 14.9096 6.43789 14.6268C6.43789 14.3441 6.52946 14.1112 6.71258 13.9283L11.3074 9.33771C11.4073 9.23792 11.5155 9.1674 11.632 9.12615C11.7486 9.08424 11.8734 9.06328 12.0066 9.06328Z"
          fill="#0276FE"
        />
      </g>
    </svg>
  );
};

export default ChevronUp;
